import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { solicitarRecuperacaoSenha as solicitarRecuperacaoSenhaService } from '../../services/authService';

const ForgotRequest: React.FC = () => {
  const [email, setEmail] = useState('');
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const resetBaseUrl = window.location.origin + '/forgot';
      await solicitarRecuperacaoSenhaService(email, resetBaseUrl);
      setEnviado(true);
    } catch (err) {
      console.error(err);
    }
  };

  const handleBackToLogin = () => {
    setEnviado(false);
    setEmail('');
    window.location.href = '/login';
  };

  return (
    <Fragment>
      <div className="main-wrap">
              <div className="nav-header bg-transparent shadow-none border-0">
                <div className="nav-top w-100">
                  <Link to="/" className='ms-5 mt-5'>
                    <img src="/assets/images/logo-inplay.png" alt="InPlay Logo" className="nav-logo" style={{ height: 60 }} />
                  </Link>
                  <button className="nav-menu me-0 ms-auto"></button>
                  <Link to="/login" className="header-btn d-none d-lg-block bg-dark fw-500 text-white font-xsss p-3 ms-auto w100 text-center lh-20 rounded-xl">Login</Link>
                  <Link to="/register" className="header-btn d-none d-lg-block bg-current fw-500 text-white font-xsss p-3 ms-2 w100 text-center lh-20 rounded-xl">Cadastrar</Link>
                </div>
              </div>
              <div className="row">
                <div
                  className="col-xl-5 d-none d-xl-block p-0 vh-100 bg-image-contain bg-no-repeat bg-primary"
                  style={{
                    backgroundImage: `url("assets/images/login-banner.png")`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain'
                  }}
                ></div>
                <div className="col-xl-7 vh-100 align-items-center d-flex bg-white rounded-3 overflow-hidden">
            <div className="card shadow-none border-0 ms-auto me-auto login-card">
              <div className="card-body rounded-0 text-left">
                {enviado ? (
                  <>
                    <h2 className="fw-700 display1-size display2-md-size mb-3">E-mail de recuperação enviado!</h2>
                    <p className="font-xsss text-grey-700">Acabamos de enviar um e-mail com todas as instruções para redefinir a sua senha. Caso não encontre o e-mail em sua caixa de entrada, favor verificar o spam.</p>
                    <button type="button" className="btn btn-primary form-control text-center style2-input fw-600 border-0 p-0 fs-5" onClick={() => handleBackToLogin()}>
                        Retornar ao Login
                    </button>
                  </>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <h2 className="fw-700 display1-size display2-md-size mb-3">Esqueci minha senha</h2>
                    <p>
                      Digite seu e-mail de cadastro abaixo e clique em enviar. Nós lhe enviaremos um e-mail com link para recadastrar a sua senha.
                    </p>
                    
                    <div className="form-group icon-input mb-3">
                      <i className="font-sm ti-email text-grey-500 pe-0"></i>
                      <input
                        type="text"
                        className="style2-input ps-5 form-control text-grey-900 font-xsss fw-600"
                        placeholder="Endereço de e-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group mb-1">
                      <button type="submit" className="btn btn-primary form-control text-center style2-input fw-600 border-0 p-0 fs-5">
                        Recuperar senha
                      </button>
                    </div>
                    <div className="col-sm-12 p-0 text-left">
                      <h6 className="text-grey-500 font-xsss fw-500 mt-0 mb-0 lh-32">
                        Chegou aqui por engano? <Link to="/login" className="fw-700 ms-1">Faça o login</Link>
                      </h6>
                    </div>
                  </form>
                  
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ForgotRequest;
